const sharedData = {};

const latestSequence = {};

export default function listActionCreators(
    resourceName,
    actionTypes,
    api,
    options
) {
    let actionCreators = {
        list: function (auth, params, mergeKey, fetchAll, shouldCancel) {
            return function (dispatch) {
                if (!latestSequence[resourceName]) {
                    latestSequence[resourceName] = {
                        controllers: {},
                        sequence: 0,
                    };
                }

                const controller = api.controller();
                const sequence = ++latestSequence[resourceName].sequence;

                if (shouldCancel !== false) {
                    Object.keys(
                        latestSequence[resourceName].controllers
                    ).forEach((ct) => {
                        console.log('CANCEL!', resourceName);
                        latestSequence[resourceName].controllers[ct].abort(
                            'Newer request'
                        );
                        delete latestSequence[resourceName].controllers[ct];
                    });
                }

                latestSequence[resourceName].controllers[sequence] = controller;

                if (fetchAll) {
                    if (sharedData[resourceName]) {
                        return;
                    }

                    sharedData[resourceName] = true;
                }

                dispatch(actionCreators.request());

                return api
                    .list(auth, params, controller)
                    .then(
                        (response) => {
                            if (
                                shouldCancel &&
                                sequence < latestSequence[resourceName].sequence
                            ) {
                                return;
                            }

                            delete latestSequence[resourceName].controllers[
                                sequence
                            ];

                            if (response.errors) {
                                dispatch(
                                    actionCreators.failure(response.errors)
                                );
                                return;
                            }

                            return dispatch(
                                actionCreators.success(response, mergeKey)
                            );
                        },
                        (exception) =>
                            dispatch(actionCreators.failure(exception))
                    )
                    .then(
                        (response) => {
                            if (!response) {
                                return;
                            }

                            return dispatch(actionCreators.complete(response));
                        },
                        () => {
                            dispatch(actionCreators.complete());
                        }
                    );
            };
        },

        request: function () {
            let name = resourceName + '_LIST_REQUEST';

            return {
                type: actionTypes[name],
            };
        },

        success: function (data, mergeKey) {
            let name = resourceName + '_LIST_SUCCESS';

            if (options.hasMeta) {
                return {
                    mergeKey: mergeKey,
                    meta: {
                        count: data.count,
                        limit: data.limit,
                        sort: data.sort,
                        offset: data.offset,
                        alphaPagination: data.alphaPagination,
                        embeds: data.embeds,
                    },
                    data: data.data,
                    type: actionTypes[name],
                };
            } else {
                return {
                    mergeKey: mergeKey,
                    data: data.data,
                    type: actionTypes[name],
                };
            }
        },

        complete: function (data) {
            let name = resourceName + '_LIST_COMPLETE';

            return {
                data: data?.data,
                type: actionTypes[name],
            };
        },

        failure: function (errors) {
            let name = resourceName + '_LIST_FAILURE';

            console.log('FAIL!', errors);

            return {
                error: errors,
                type: actionTypes[name],
            };
        },

        clear: function () {
            let name = resourceName + '_LIST_CLEAR';

            return {
                data: {},
                type: actionTypes[name],
            };
        },

        setItem: function (item) {
            let name = resourceName + '_LIST_SETITEM';

            return {
                data: {
                    item: item,
                },
                type: actionTypes[name],
            };
        },

        cancel: function (controller) {
            return function (dispatch) {
                api.cancel(controller);
                dispatch(actionCreators.cancelRequest());
            };
        },

        cancelRequest: function () {
            let name = resourceName + '_LIST_CANCEL';
            return {
                type: actionTypes[name],
            };
        },
    };

    return {
        cancel: actionCreators.cancel,
        list: actionCreators.list,
        listClear: actionCreators.clear,
        listSetItem: actionCreators.setItem,
    };
}
